import chooseUsBg1 from '@/assets/images/home/chooseus-bg-1.jpg'
import statsBg from '@/assets/images/home/stats-bg.jpg'
import { SectionTitle } from '@/components/SectionTitle'
import { pageMaxWidth, pageXPadding, pageYPadding } from '@/config'
import { Cards } from '../Cards'
import { Stats } from '../Stats'
export const ChooseUs = () => {
  return (
    <>
      <section className={`${pageXPadding} ${pageYPadding}`}>
        <div className={`${pageMaxWidth} mx-auto`}>
          <SectionTitle variant="secondary" title="Why Choose Us?" />
          <div className="relative mb-[40px] mt-[20px] flex justify-start pl-[40px] pt-[189px] md:px-[40px] lg:mb-0 lg:px-[119px]">
            <div className="absolute right-0 top-0 h-[781px] w-full  max-w-[226px]  translate-x-[10%] border-4 border-[#D4AF37] md:max-w-[334px]  lg:max-w-[443px]"></div>

            <div className="absolute bottom-0 left-0 h-[361px] w-full max-w-[226px] translate-y-2/3 border-4  border-[#D4AF37] md:max-w-[334px] md:-translate-x-1/4  lg:h-[664px] lg:max-w-[443px]"></div>

            <img
              className="absolute left-1/2 top-[50px] h-auto max-h-[226px]   w-11/12 max-w-[942px] -translate-x-1/2 object-cover"
              src={chooseUsBg1}
            />
            <div className="z-10 ">
              <Cards />
            </div>
          </div>
        </div>
      </section>
      <section className={`${pageXPadding} ${pageYPadding} relative z-10`}>
        <div
          className={`${pageMaxWidth} mx-auto flex flex-col items-center gap-x-[97px] gap-y-[27px] pt-[20px] md:flex-row md:items-start md:gap-x-[50px] lg:pt-0`}
        >
          <img
            src={statsBg}
            className="h-[238px] w-[221px] shrink-0 rounded-bl-[75px] rounded-tr-[75px] lg:h-[459px] lg:w-[427px] "
          />
          <div className="flex flex-col items-center justify-center gap-y-[12px]  ">
            <span className="text-center font-nunito text-[24px] font-bold leading-[38.4px] text-[#333333] md:text-[28px] md:leading-[44.8px] lg:text-start lg:text-[32px] lg:leading-[51.2px]">
              Transform Your Space into a{' '}
              <span className="text-[#D4AF37] ">Modern Haven</span>
            </span>
            <p className="text-center font-nunito text-[12px] leading-[19.2px] text-[#333333] md:text-start md:text-[14px] md:leading-[22.4px] lg:text-[16px] lg:leading-[25.6px] ">
              {`Step into a world where sleek design meets comfort. Let's redefine
              your interiors with a modern touch that reflects your style.`}
            </p>
            <div className="flex w-full justify-center gap-x-[24px] md:justify-start md:gap-x-[26px] lg:gap-x-[60px]">
              <Stats />
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
